module.exports = __webpack_public_path__ + "assets/img/kv-e26e7edc.jpg";